import React, { useState } from 'react';
import { BsTicketPerforated } from 'react-icons/bs';
import { FaRupeeSign } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { BsActivity } from 'react-icons/bs';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';

import 'bootstrap/dist/css/bootstrap.min.css';


const DashboardSuper = () => {
    const [showBookings, setShowBookings] = useState(false);
    const [showRevenue, setShowRevenue] = useState(false);
    const [showCounterTicket, setShowCounterTicket] = useState(false);
    const [showCounterRevenue, setShowCounterRevenue] = useState(false);

    const [counterRevenueFilter, setCounterRevenueFilter] = useState('All Time');
    const [counterStartDate, setCounterStartDate] = useState(null);
    const [counterEndDate, setCounterEndDate] = useState(null);
    const [customDateOption, setCustomDateOption] = useState('');

    const [showTotalEarning, setShowTotalEarning] = useState(false);
    const [earningFilter, setEarningFilter] = useState("All Time");

    const [showActiveUserModal, setShowActiveUserModal] = useState(false);

    const [showEarningModal, setShowEarningModal] = useState(false);

    const [show, setShow] = useState(false);


    const dataAllTime = [
        { name: 'Jan', Bookings: 186 },
        { name: 'Feb', Bookings: 310 },
        { name: 'Mar', Bookings: 240 },
        { name: 'Apr', Bookings: 270 },
        { name: 'May', Bookings: 200 },
        { name: 'Jun', Bookings: 210 },
    ];
    const counterRevenueData = [
        { name: 'Jan', Revenue: 300 },
        { name: 'Feb', Revenue: 400 },
        { name: 'Mar', Revenue: 500 },
        { name: 'Apr', Revenue: 600 },
        { name: 'May', Revenue: 950 },
        { name: 'Jun', Revenue: 1100 },
    ];
    const data = [
        { month: "Jan", appUsers: 2000, webUsers: 1950 },
        { month: "Feb", appUsers: 2050, webUsers: 2000 },
        { month: "Mar", appUsers: 2100, webUsers: 2070 },
        { month: "Apr", appUsers: 2200, webUsers: 2500 },
        { month: "May", appUsers: 2300, webUsers: 2500 },
        { month: "Jun", appUsers: 2400, webUsers: 2550 },
    ];
    const [showModal, setShowModal] = useState(false);
    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    return (
        <Wrapper>
            <div className="py-4">
                <div className="page-header pb-3">
                    <h4 className="page-title">Super Admin Dashboard</h4>
                    <p className="text-white mb-0">Overview of platform activity and key metrics</p>
                </div>
                <div className="row pb-3">
                    <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                        <div className="p-3 rounded shadow-sm bg-white">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="mb-0 text-secondary fw-bold text-dark">Total Bookings</h6>
                                <BsTicketPerforated size={20} className="text-secondary" />
                            </div>
                            <h3
                                className="mb-0 fw-bold text-dark"
                                onClick={() => setShowBookings(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                15,670
                            </h3>
                            <small className="text-muted">Online ticket bookings all time</small>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                        <div className="p-3 rounded shadow-sm bg-white">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="mb-0 text-secondary fw-bold text-dark">Total Revenue</h6>
                                <FaRupeeSign size={20} className="text-muted" />
                            </div>
                            <h3
                                className="mb-0 fw-bold text-dark"
                                onClick={() => setShowRevenue(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                391,750.00
                            </h3>
                            <small className="text-muted">Revenue from Online ticket sales all</small>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                        <div className="p-3 rounded shadow-sm bg-white">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="mb-0 text-secondary fw-bold text-dark">Total Counter Ticket</h6>
                                <BsTicketPerforated size={20} className="text-secondary" />
                            </div>
                            <h3
                                className="mb-0 fw-bold text-dark"
                                onClick={() => setShowCounterTicket(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                2,350
                            </h3>
                            <small className="text-muted">Counter tickets generated all time</small>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                        <div className="p-3 rounded shadow-sm bg-white">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="mb-0 text-secondary fw-bold text-dark">Total Counter Revenue</h6>
                                <FaRupeeSign size={20} className="text-muted" />
                            </div>
                            <h3
                                className="mb-0 fw-bold text-dark"
                                onClick={() => setShowCounterRevenue(true)}
                                style={{ cursor: 'pointer' }}
                            >
                                4,568.25
                            </h3>
                            <small className="text-muted">Revenue from counter tickets all time</small>
                        </div>
                    </div>
                    
                </div>
            </div>

            <Modal show={showBookings} onHide={() => setShowBookings(false)} centered>
                <Modal.Header>
                    <div className="w-100 d-flex justify-content-between align-items-start">
                        <div>
                            <h5 className="fw-bold mb-0">Booking Trends</h5>
                            <small className="text-muted">Monthly bookings overview</small>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <select className="form-select w-auto total-booking">
                                <option>All Time</option>
                                <option>This Month</option>
                                <option>This Week</option>
                                <option>Today</option>
                            </select>
                            <button
                                type="button"
                                className="btn-close total-booking-close"
                                onClick={() => setShowBookings(false)}
                                aria-label="Close"
                            />
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="p-0">
                    <div className="rounded bg-white shadow-sm" style={{ maxWidth: 700 }}>
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={dataAllTime} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip
                                    contentStyle={{ borderRadius: 6 }}
                                    formatter={(value) => [`${value}`, 'Bookings']}
                                />
                                <Bar dataKey="Bookings" fill="#F2673A" radius={[4, 4, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showRevenue} onHide={() => setShowRevenue(false)} centered>
                <Modal.Header className="border-0">
                    <div className="w-100 d-flex justify-content-between align-items-start">
                        <div>
                            <h5 className="fw-bold mb-0">Revenue Trends</h5>
                            <small className="text-muted">Monthly revenue overview</small>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <select
                                className="form-select w-auto revenue-trends-filter"
                                id="revenueTrendsFilter"
                                style={{ minWidth: 160 }}
                            >
                                <option>All Time</option>
                                <option>Highest Revenue</option>
                                <option>Custom Date/Range</option>
                            </select>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowRevenue(false)}
                                aria-label="Close"
                            />
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="p-0">
                    <div className="rounded bg-white shadow-sm p-3" id="revenue-chart-container" style={{ maxWidth: 700 }}>
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                                data={dataAllTime}
                                margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
                            >
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip
                                    contentStyle={{ borderRadius: 6 }}
                                    formatter={(value) => [`₹${value}`, 'Revenue']}
                                />
                                <Bar dataKey="Bookings" fill="#2CA58D" radius={[4, 4, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showCounterTicket} onHide={() => setShowCounterTicket(false)} centered>
                <Modal.Header className="border-0">
                    <div className="w-100 d-flex justify-content-between align-items-start">
                        <div>
                            <h5 className="fw-bold mb-0">Counter Ticket Sales Trends</h5>
                            <small className="text-muted">Monthly counter sales overview</small>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <select
                                className="form-select w-auto counter-sales-filter"
                                id="counterSalesFilter"
                                style={{ minWidth: 180 }}
                            >
                                <option>Highest Counter Sales</option>
                                <option>All Time</option>
                                <option>Custom Date/Range</option>
                            </select>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowCounterTicket(false)}
                                aria-label="Close"
                            />
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="p-0">
                    <div className="rounded bg-white shadow-sm p-3" id="counter-chart-container" style={{ maxWidth: 700 }}>
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                                data={[{ name: 'Jun', CounterSales: 68 }]}
                                margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
                            >
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip
                                    contentStyle={{ borderRadius: 6 }}
                                    formatter={(value) => [`${value}`, 'Counter Sales']}
                                />
                                <Bar dataKey="CounterSales" fill="#0C3C4C" radius={[4, 4, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showCounterRevenue} onHide={() => setShowCounterRevenue(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Modal.Header
                            className="border-0 d-flex align-items-center justify-content-between flex-wrap"
                        >
                            <h5 className="fw-bold mb-0">Counter Revenue Trends</h5>

                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {/* Select Dropdown */}
                                <select
                                    className="form-select w-auto"
                                    value={counterRevenueFilter}
                                    onChange={(e) => setCounterRevenueFilter(e.target.value)}
                                >
                                    <option>Custom Date/Range</option>
                                    <option>All Date</option>
                                </select>
                            </div>
                        </Modal.Header>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <div
                        className="position-relative rounded bg-white shadow-sm p-3"
                        style={{ maxWidth: 700, minHeight: 300 }}
                    >
                        <ResponsiveContainer width="100%" height={250}>
                            <BarChart
                                data={counterRevenueData}
                                margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
                            >
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip
                                    contentStyle={{ borderRadius: 6 }}
                                    formatter={(value) => [`₹${value}`, 'Revenue']}
                                />
                                <Bar dataKey="Revenue" fill="#F7941D" radius={[4, 4, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </Modal.Body>
            </Modal>

            <div className="container">
                <div className="row py-4 bg-light rounded">
                    <div className="col-12 mb-3">
                        <div className="mb-3 d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold text-dark mb-0">Earnings Overview</h4>
                            <select className="form-select w-auto">
                                <option>All Time</option>
                                <option>This Month</option>
                                <option>This Week</option>
                                <option>Today</option>
                            </select>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Total Earning</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>

                                    <h3
                                        className="mb-0 fw-bold text-dark"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShowTotalEarning(true)}
                                    >
                                        ₹127,930.50
                                    </h3>

                                    <small className="text-muted">Across all time</small>
                                </div>
                            </div>
                            <Modal
                                show={showTotalEarning}
                                onHide={() => setShowTotalEarning(false)}
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        <h5 className="fw-bold mb-0">Total Earnings Breakdown</h5>
                                        <small className="text-muted ">Breakdown across all time</small>
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="p-0 ">
                                    <div className="p-4 rounded shadow-sm bg-white" style={{ maxWidth: '500px' }}>
                                        <div className="mb-2 d-flex justify-content-between">
                                            <span>Convenience Fee Earnings:</span>
                                            <span>$95,250.00</span>
                                        </div>
                                        <div className="mb-2 d-flex justify-content-between">
                                            <span>Platform Fee Earnings:</span>
                                            <span>$15,180.50</span>
                                        </div>
                                        <div className="mb-2 d-flex justify-content-between">
                                            <span>One Time Reg. Fees:</span>
                                            <span>$2,500.00</span>
                                        </div>
                                        <div className="mb-2 d-flex justify-content-between">
                                            <span>Advertising Fee Earnings:</span>
                                            <span>$10,000.00</span>
                                        </div>
                                        <div className="mb-4 d-flex justify-content-between">
                                            <span>Subscription Earnings:</span>
                                            <span>$5,000.00</span>
                                        </div>

                                        <div className="border-top pt-3 d-flex justify-content-between fw-bold fs-5">
                                            <span>Total Earnings:</span>
                                            <span className="text-primary">$127,930.50</span>
                                        </div>
                                    </div>

                                </Modal.Body>
                            </Modal>

                            <div className="col-lg-4 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Total Revenue</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">₹ 5,20,000</h3>
                                    <small className="text-muted">All-time revenue</small>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Total Users</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">3,200</h3>
                                    <small className="text-muted">Active users on platform</small>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Cancelled Tickets</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">110</h3>
                                    <small className="text-muted">All-time cancellations</small>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Platform Fees</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">₹ 35,000</h3>
                                    <small className="text-muted">From all time</small>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Commission</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">₹ 12,000</h3>
                                    <small className="text-muted">Partner commission earnings</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row bg-light rounded">
                    <div className="col-12 mb-3">
                        <div className="mb-3 d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold text-dark mb-0">Settlement and payout overview</h4>
                            <select className="form-select w-auto">
                                <option>All Time</option>
                                <option>This Month</option>
                                <option>This Week</option>
                                <option>Today</option>
                            </select>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Total Bookings</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">15,670</h3>
                                    <small className="text-muted">Online ticket bookings all time</small>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Total Revenue</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">₹ 5,20,000</h3>
                                    <small className="text-muted">All-time revenue</small>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Total Users</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">3,200</h3>
                                    <small className="text-muted">Active users on platform</small>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Cancelled Tickets</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">110</h3>
                                    <small className="text-muted">All-time cancellations</small>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Platform Fees</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">₹ 35,000</h3>
                                    <small className="text-muted">From all time</small>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Commission</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">₹ 12,000</h3>
                                    <small className="text-muted">Partner commission earnings</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row bg-light rounded">
                    <div className="col-12 mb-3 pt-3">
                        <div className="mb-3 d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold text-dark mb-0">User Overview</h4>
                            <select className="form-select w-auto">
                                <option>All Time</option>
                                <option>This Month</option>
                                <option>This Week</option>
                                <option>Today</option>
                            </select>
                        </div>
                        <div className="row">

                            <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">All Active User</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3
                                        className="mb-0 fw-bold text-dark"
                                        style={{ cursor: "pointer" }}
                                        onClick={handleShow}
                                    >
                                        2,681
                                    </h3>
                                    <small className="text-muted">Average all time</small>
                                </div>
                            </div>

                            <Modal show={showModal} onHide={handleClose} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title><h5 className='fw-bold mb-0'>Active User Breakdown</h5></Modal.Title>
                                </Modal.Header>
                                <Modal.Body >
                                    <div style={{ width: "100%", height: 300 }}>
                                        <ResponsiveContainer>
                                            <BarChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="month" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                <Bar dataKey="appUsers" name="App Users (Total)" fill="#3b4cca" />
                                                <Bar dataKey="webUsers" name="Web Users" fill="#44c2c0" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </Modal.Body>
                            </Modal>

                            <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Total Revenue</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">₹ 5,20,000</h3>
                                    <small className="text-muted">Overall platform revenue</small>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Website Active Users</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3
                                        className="mb-0 fw-bold text-dark"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShow(true)}
                                    >
                                        1,681
                                    </h3>
                                    <small className="text-muted">Via web browser</small>
                                </div>
                            </div>

                            <Modal show={show} onHide={() => setShow(false)} centered>
                                <Modal.Header closeButton>
                                    <div className="w-100 d-flex justify-content-between align-items-start">
                                        <div>
                                            <h5 className="fw-bold mb-0">Website Active Users Trends</h5>
                                        </div>
                                        <div>
                                            <select className="form-select w-auto ms-3">
                                                <option>All Time</option>
                                                <option>This Month</option>
                                                <option>This Week</option>
                                                <option>Today</option>
                                            </select>
                                        </div>
                                    </div>

                                </Modal.Header>
                                <Modal.Body>
                                    <div style={{ width: "100%", height: 300 }}>
                                        <ResponsiveContainer>
                                            <BarChart
                                                data={data}
                                                margin={{ top: 10, right: 30, left: 0, bottom: 5 }}
                                                barSize={40}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="month" />
                                                <YAxis />
                                                <Tooltip />
                                                <Bar dataKey="webUsers" fill="#44c2c0" radius={[6, 6, 0, 0]} />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </Modal.Body>
                            </Modal>

                            <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Commission</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">₹ 28,900</h3>
                                    <small className="text-muted">Earned from partners</small>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row bg-light rounded">
                    <div className="col-12 mb-3 pt-3">
                        <div className="mb-3 d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold text-dark mb-0">Partner Overview</h4>
                            <select className="form-select w-auto">
                                <option>All Time</option>
                                <option>This Month</option>
                                <option>This Week</option>
                                <option>Today</option>
                            </select>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Total Bookings</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">15,670</h3>
                                    <small className="text-muted">Online ticket bookings all time</small>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Total Revenue</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">₹ 5,20,000</h3>
                                    <small className="text-muted">Overall platform revenue</small>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Active Users</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">3,245</h3>
                                    <small className="text-muted">Currently using the platform</small>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0 text-secondary fw-bold text-dark">Commission</h6>
                                        <BsTicketPerforated size={20} className="text-secondary" />
                                    </div>
                                    <h3 className="mb-0 fw-bold text-dark">₹ 28,900</h3>
                                    <small className="text-muted">Earned from partners</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row bg-light rounded">
                    <div className="col-12 mb-3 pt-3">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                                <div className="p-3 rounded shadow-sm bg-white">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h4 className="fw-bold text-dark mb-0">Recent Activities</h4>
                                    </div>
                                    <p className="text-muted">Online ticket bookings all time</p>
                                    <div className="d-flex align-items-start justify-content-between mb-3">
                                        <div className="d-flex align-items-start">
                                            <div className="me-3">
                                                <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                                                    <BsActivity size={18} className="text-primary" />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="fw-semibold text-dark">New Partner Inc.</div>
                                                <small className="text-muted">joined the platform.</small>
                                            </div>
                                        </div>
                                        <small className="text-muted">5m ago</small>
                                    </div>
                                    <div className="d-flex align-items-start justify-content-between mb-3">
                                        <div className="d-flex align-items-start">
                                            <div className="me-3">
                                                <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                                                    <BsActivity size={18} className="text-primary" />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="fw-semibold text-dark">Adventure Park</div>
                                                <small className="text-muted">joined the platform.</small>
                                            </div>
                                        </div>
                                        <small className="text-muted">5m ago</small>
                                    </div>
                                    <div className="d-flex align-items-start justify-content-between mb-3">
                                        <div className="d-flex align-items-start">
                                            <div className="me-3">
                                                <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 40, height: 40 }}>
                                                    <BsActivity size={18} className="text-primary" />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="fw-semibold text-dark">Refund Request</div>
                                                <small className="text-muted">joined the platform.</small>
                                            </div>
                                        </div>
                                        <small className="text-muted">5m ago</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};


export default DashboardSuper;

const Wrapper = styled.div`
  select.form-select.w-auto.total-booking {
    margin-left: 50px !important;
  }
`;
